import { requiredPropWarningFactory } from "@bookingcom/bui-core/utilities/helpers";
export const useRequiredPropWarning = requiredPropWarningFactory("BUI React", "throw");
